import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC } from "react";
import styled from "styled-components";
import { Introduction1BusinessCardContent } from "types/graphql/generated";
import { CardOption } from "./CardOption";

interface Props {
  className?: string;
  content: Introduction1BusinessCardContent;
}

const BusinessCard: FC<Props> = withErrorBoundary(
  ({
    className = "",
    content: { title, linkOne, linkLabelOne, linkTwo, linkLabelTwo, descriptionOne, descriptionTwo },
  }) => {
    return (
      <StyledBusinessCard className={className}>
        <h2 className="BusinessCard__title Color_eucalyptus5 Font_24_32_600">{title}</h2>
        <ul className="BusinessCard__content">
          <li className="BusinessCard__optionContainer">
            <CardOption
              className="BusinessCard__option"
              link={linkOne}
              label={linkLabelOne}
              description={descriptionOne}
            />
          </li>
          <li className="BusinessCard__optionContainer">
            <CardOption
              className="BusinessCard__option"
              link={linkTwo}
              label={linkLabelTwo}
              description={descriptionTwo}
            />
          </li>
        </ul>
      </StyledBusinessCard>
    );
  },
  {}
);

const StyledBusinessCard = styled.div`
  .BusinessCard__title {
    width: fit-content;
    padding: 12px 32px;
    border-radius: 32px;
    background-color: ${({ theme }) => theme.colors.eucalyptus["80"]};
  }

  .BusinessCard__content {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
  }

  .BusinessCard__optionContainer {
    max-width: 276px;
  }

  .BusinessCard__optionContainer:not(:first-child) {
    margin-left: 24px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .BusinessCard__optionContainer {
      max-width: 50%;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .BusinessCard__content {
      flex-direction: column;
      margin-top: 24px;
    }

    .BusinessCard__optionContainer {
      max-width: unset;
    }

    .BusinessCard__optionContainer:not(:first-child) {
      margin-top: 24px;
      margin-left: 0;
    }
  }
`;

gql`
  fragment Introduction1BusinessCardContent on ComponentNestedIntroduction1Business {
    title
    linkOne
    linkLabelOne
    linkTwo
    linkLabelTwo
    descriptionOne
    descriptionTwo
  }
`;

export { BusinessCard };
